import { SvgIcon } from '@mui/material';
import { ReactComponent as Dashboard } from 'assets/images/ic_dashboard.svg';
import { ReactComponent as AssessmIcon } from 'assets/images/assessm_template.svg';
import { ReactComponent as InventoryIcon } from 'assets/images/ic_inventory.svg';
import { ReactComponent as ApproversIcon } from 'assets/images/ic_approvers.svg';
import { ReactComponent as AuditReadiness } from 'assets/images/ic_audit_readiness.svg';

import { ReactComponent as Data } from 'assets/images/ic_data.svg';
import { ReactComponent as Discovery } from 'assets/images/ic_discovery.svg';
import { ReactComponent as EnterprisePortal } from 'assets/images/ic_enterprise_portal.svg';
import { ReactComponent as Incidents } from 'assets/images/ic_incidents.svg';
import { ReactComponent as Maturity } from 'assets/images/ic_maturity.svg';
import { ReactComponent as Overview } from 'assets/images/ic_overview.svg';
import { ReactComponent as PoliciesManagem } from 'assets/images/ic_policies_managem.svg';
import { ReactComponent as Policies } from 'assets/images/ic_policies.svg';
import { ReactComponent as Register } from 'assets/images/ic_register.svg';
import { ReactComponent as Override } from 'assets/images/ic_risk_overvie.svg';
import { ReactComponent as IncidentsLog } from 'assets/images/incid_log-icon.svg';
import { ReactComponent as IncidentsDashboard } from 'assets/images/inc_dash-icon.svg';
import { ReactComponent as RiskAssessm } from 'assets/images/ic_risk_assessm.svg';
import { ReactComponent as RiskMan } from 'assets/images/ic_risk_man.svg';
import { ReactComponent as TrainingProgram } from 'assets/images/ic_training_program.svg';
import { ReactComponent as Training } from 'assets/images/ic_training.svg';
import { ReactComponent as ComplianceTracking } from 'assets/images/ic_compliance_tracking.svg';
import { ReactComponent as Vulnerab } from 'assets/images/ic_vulnerab.svg';
import { ReactComponent as PartnersHub } from 'assets/images/ic_partner_hub.svg';
import { ReactComponent as MCPServers } from 'assets/images/mcp-server.svg';
import ShareIcon from '@mui/icons-material/Share';
import { ReactComponent as AIRiskBaseline } from 'assets/images/clipboard-icon.svg';
import { ReactComponent as Sensitive } from 'assets/images/sensitive.svg';
import { ReactComponent as System } from 'assets/images/ic_system.svg';
import { EMenuType } from 'shared/components/AppSidebar';

/**
 * Default sidebar configuration.
 */
export const DefaultSidebar: any[] = [
  {
    path: '/overview',
    title: 'Dashboard',
    icon: (
      <SvgIcon
        component={Dashboard}
        inheritViewBox
        className="menu-icon"
        fontSize="inherit"
        htmlColor="#3D3C42"
      />
    ),
    key: 'overview',
    aclKey: 'dashboard',
    navigationType: EMenuType.NAVIGATION,
    superFlag: null,
    childrenMenus: [
      {
        path: '/overview',
        title: 'Overview',
        icon: (
          <SvgIcon
            component={Overview}
            inheritViewBox
            className="menu-icon"
            fontSize="inherit"
            htmlColor="#3D3C42"
          />
        ),
        key: 'overview',
        aclKey: 'dashboard.overview',
        navigationType: EMenuType.NAVIGATION,
        superFlag: null,
      },
      {
        path: '/ai-maturity',
        title: 'AI Maturity',
        icon: (
          <SvgIcon
            component={Maturity}
            inheritViewBox
            className="menu-icon"
            fontSize="inherit"
            htmlColor="#3D3C42"
          />
        ),
        key: 'ai-maturity',
        aclKey: 'dashboard.aiMaturity',
        navigationType: EMenuType.NAVIGATION,
        superFlag: null,
      },
      {
        path: '/enterprise-portal',
        title: 'Enterprise Portal',
        icon: (
          <SvgIcon
            component={EnterprisePortal}
            inheritViewBox
            className="menu-icon"
            fontSize="inherit"
            htmlColor="#3D3C42"
          />
        ),
        key: 'enterprise-portal',
        aclKey: 'dashboard.enterprisePortal',
        navigationType: EMenuType.NAVIGATION,
        superFlag: null,
      },
      {
        path: '/partners-hub',
        title: 'Partners Hub',
        icon: (
          <SvgIcon
            component={PartnersHub}
            inheritViewBox
            className="menu-icon"
            fontSize="inherit"
            htmlColor="#3D3C42"
          />
        ),
        key: 'partners-hub',
        aclKey: 'dashboard.partnersHub',
        navigationType: EMenuType.NAVIGATION,
        superFlag: null,
      },
      {
        path: '/ai-risk-baseline',
        title: 'AI Risk Baseline',
        icon: (
          <SvgIcon
            component={AIRiskBaseline}
            inheritViewBox
            className="menu-icon"
            fontSize="inherit"
            htmlColor="#3D3C42"
          />
        ),
        key: 'ai-risk-baseline',
        aclKey: 'dashboard.aiRiskBaseLine',
        navigationType: EMenuType.NAVIGATION,
        superFlag: null,
      },
    ],
  },
  {
    path: '/ai-inventory',
    title: 'AI Inventory',
    icon: (
      <SvgIcon
        component={InventoryIcon}
        inheritViewBox
        className="menu-icon"
        fontSize="inherit"
        htmlColor="#3D3C42"
      />
    ),
    key: 'ai-inventory',
    aclKey: 'aiInventory',
    navigationType: EMenuType.NAVIGATION,
    superFlag: null,
    childrenMenus: [
      {
        path: '/ai-systems',
        title: 'AI System',
        icon: (
          <SvgIcon
            component={System}
            inheritViewBox
            className="menu-icon"
            fontSize="inherit"
            htmlColor="#3D3C42"
          />
        ),
        key: 'ai-system',
        aclKey: 'aiInventory.aiSystem',
        navigationType: EMenuType.NAVIGATION,
        superFlag: null,
      },
      {
        path: '/datasets',
        title: 'Datasets',
        icon: (
          <SvgIcon
            component={Data}
            inheritViewBox
            className="menu-icon"
            fontSize="inherit"
            htmlColor="#3D3C42"
          />
        ),
        key: 'datasets',
        aclKey: 'aiInventory.datasets',
        navigationType: EMenuType.NAVIGATION,
        superFlag: null,
      },
      {
        path: '/sensitivity-types',
        title: 'Sensitivity Types',
        icon: (
          <SvgIcon
            component={Sensitive}
            inheritViewBox
            className="menu-icon"
            fontSize="inherit"
            htmlColor="#3D3C42"
          />
        ),
        key: 'sensitivity-types',
        aclKey: 'aiInventory.sensitivityTypes',
        navigationType: EMenuType.NAVIGATION,
        superFlag: null,
      },
      {
        path: '/discovery-ai',
        title: 'Discovery AI',
        icon: (
          <SvgIcon
            component={Discovery}
            inheritViewBox
            className="menu-icon"
            fontSize="inherit"
            htmlColor="#3D3C42"
          />
        ),
        key: 'discovery-ai',
        aclKey: 'aiInventory.discoveryAI',
        navigationType: EMenuType.NAVIGATION,
        superFlag: null,
      },
      {
        path: '/mcp-servers',
        title: 'MCP Servers',
        icon: (
          <SvgIcon
            component={MCPServers}
            inheritViewBox
            className="menu-icon"
            fontSize="inherit"
            htmlColor="#3D3C42"
          />
        ),
        key: 'mcp-servers',
        aclKey: 'aiInventory.mcpServers',
        navigationType: EMenuType.NAVIGATION,
        superFlag: null,
      },
    ],
  },
  {
    path: '/risk-management',
    title: 'Risk Management',
    icon: (
      <SvgIcon
        component={RiskMan}
        inheritViewBox
        className="menu-icon"
        fontSize="inherit"
        htmlColor="#3D3C42"
      />
    ),
    key: 'risk-management',
    aclKey: 'riskManagement',
    navigationType: EMenuType.NAVIGATION,
    superFlag: null,
    childrenMenus: [
      {
        path: '/risk-overview',
        title: 'Risk Overview',
        comingSoon: false,
        icon: (
          <SvgIcon
            component={Override}
            inheritViewBox
            className="menu-icon"
            fontSize="inherit"
            htmlColor="#3D3C42"
          />
        ),
        key: 'risk-overview',
        aclKey: 'riskManagement.riskOverview',
        navigationType: EMenuType.NAVIGATION,
        superFlag: null,
      },
      {
        path: '/risk-register',
        title: 'Risk Register',
        icon: (
          <SvgIcon
            component={Register}
            inheritViewBox
            className="menu-icon"
            fontSize="inherit"
            htmlColor="#3D3C42"
          />
        ),
        key: 'risk-register',
        aclKey: 'riskManagement.riskRegister',
        navigationType: EMenuType.NAVIGATION,
        superFlag: null,
      },
      {
        path: '/risk-assessments',
        title: 'Risk Assessments',
        icon: (
          <SvgIcon
            component={RiskAssessm}
            inheritViewBox
            className="menu-icon"
            fontSize="inherit"
            htmlColor="#3D3C42"
          />
        ),
        key: 'risk-assessments',
        aclKey: 'riskManagement.riskAssessments',
        navigationType: EMenuType.NAVIGATION,
        superFlag: null,
      },
      {
        path: '/external-assessments',
        title: 'External Assessments',
        icon: <ShareIcon className="menu-icon" htmlColor="#3D3C42" />,
        key: 'external-assessments',
        aclKey: 'riskManagement.externalAssessments',
        navigationType: EMenuType.NAVIGATION,
        superFlag: null,
      },
      {
        path: '/assessment-templates',
        title: 'Assessment Templates',
        icon: (
          <SvgIcon
            component={AssessmIcon}
            inheritViewBox
            className="menu-icon"
            fontSize="inherit"
            htmlColor="#3D3C42"
          />
        ),
        key: 'assessment-templates',
        aclKey: 'riskManagement.assessmentTemplates',
        navigationType: EMenuType.NAVIGATION,
        superFlag: null,
      },
      {
        path: '/tier-approvers',
        title: 'Tier Approvers',
        icon: (
          <SvgIcon
            component={ApproversIcon}
            inheritViewBox
            className="menu-icon"
            fontSize="inherit"
            htmlColor="#3D3C42"
          />
        ),
        key: 'tier-approvers',
        aclKey: 'riskManagement.tierApprovers',
        navigationType: EMenuType.NAVIGATION,
        superFlag: null,
      },
    ],
  },
  {
    path: '/training',
    title: 'Training',
    icon: (
      <SvgIcon
        component={Training}
        inheritViewBox
        className="menu-icon"
        fontSize="inherit"
        htmlColor="#3D3C42"
      />
    ),
    key: 'training',
    aclKey: 'training',
    navigationType: EMenuType.NAVIGATION,
    superFlag: null,
    childrenMenus: [
      {
        path: '/training-programs',
        title: 'Training Programs',
        icon: (
          <SvgIcon
            component={TrainingProgram}
            inheritViewBox
            className="menu-icon"
            fontSize="inherit"
            htmlColor="#3D3C42"
          />
        ),
        key: 'training-programs',
        aclKey: 'training.trainingPrograms',
        navigationType: EMenuType.NAVIGATION,
        superFlag: null,
      },
    ],
  },
  {
    path: '/compliance',
    title: 'Compliance',
    icon: (
      <SvgIcon
        component={ComplianceTracking}
        inheritViewBox
        className="menu-icon"
        fontSize="inherit"
        htmlColor="#3D3C42"
      />
    ),
    key: 'compliance',
    aclKey: 'compliance',
    navigationType: EMenuType.NAVIGATION,
    superFlag: null,
    childrenMenus: [
      {
        path: '/compliance-tracking',
        title: 'Compliance Tracking',
        icon: (
          <SvgIcon
            component={ComplianceTracking}
            inheritViewBox
            className="menu-icon"
            fontSize="inherit"
            htmlColor="#3D3C42"
          />
        ),
        key: 'compliance-tracking',
        aclKey: 'compliance.tracking',
        navigationType: EMenuType.NAVIGATION,
        superFlag: null,
      },
    ],
  },
  {
    path: '/policies',
    title: 'Policies',
    icon: (
      <SvgIcon
        component={Policies}
        inheritViewBox
        className="menu-icon"
        fontSize="inherit"
        htmlColor="#3D3C42"
      />
    ),
    key: 'policies',
    aclKey: 'policies',
    navigationType: EMenuType.NAVIGATION,
    superFlag: null,
    childrenMenus: [
      {
        path: '/policy-management',
        title: 'Policy Management',
        icon: (
          <SvgIcon
            component={PoliciesManagem}
            inheritViewBox
            className="menu-icon"
            fontSize="inherit"
            htmlColor="#3D3C42"
          />
        ),
        key: 'policy-management',
        aclKey: 'policies.policyManagement',
        navigationType: EMenuType.NAVIGATION,
        superFlag: null,
      },
      {
        path: '/guardrails',
        title: 'Guardrails',
        comingSoon: false,
        icon: <img src="/images/icons/IconShield.svg" />,
        key: 'audit-readiness',
        aclKey: 'policies.guardrails',
        navigationType: EMenuType.NAVIGATION,
        superFlag: null,
      },
      {
        path: '/audit-readiness',
        title: 'Approval Gates',
        icon: (
          <SvgIcon
            component={AuditReadiness}
            inheritViewBox
            className="menu-icon"
            fontSize="inherit"
            htmlColor="#3D3C42"
          />
        ),
        key: 'audit-readiness',
        aclKey: 'policies.approvalGates',
        navigationType: EMenuType.NAVIGATION,
        superFlag: null,
      },
    ],
  },
  {
    path: '/incidents',
    title: 'Incidents',
    icon: (
      <SvgIcon
        component={Incidents}
        inheritViewBox
        className="menu-icon"
        fontSize="inherit"
        htmlColor="#3D3C42"
      />
    ),
    key: 'incidents',
    aclKey: 'incidents',
    navigationType: EMenuType.NAVIGATION,
    superFlag: null,
    childrenMenus: [
      {
        path: '/incidents-log',
        title: 'Incidents Log',
        comingSoon: false,
        icon: (
          <SvgIcon
            component={IncidentsLog}
            inheritViewBox
            className="menu-icon"
            fontSize="inherit"
            htmlColor="#3D3C42"
          />
        ),
        key: 'incidents-log',
        aclKey: 'incidents.incidentsLog',
        navigationType: EMenuType.NAVIGATION,
        superFlag: null,
      },
      {
        path: '/incidents-dashboard',
        title: 'Incidents Dashboard',
        comingSoon: false,
        icon: (
          <SvgIcon
            component={IncidentsDashboard}
            inheritViewBox
            className="menu-icon"
            fontSize="inherit"
            htmlColor="#3D3C42"
          />
        ),
        key: 'incidents-dashboard',
        aclKey: 'incidents.incidentsDashboard',
        navigationType: EMenuType.NAVIGATION,
        superFlag: null,
      },
    ],
  },
  {
    path: '/vulnerabilities',
    title: 'Vulnerabilities',
    icon: (
      <SvgIcon
        component={Vulnerab}
        inheritViewBox
        className="menu-icon"
        fontSize="inherit"
        htmlColor="#3D3C42"
      />
    ),
    key: 'vulnerabilities',
    aclKey: 'vulnerabilities',
    navigationType: EMenuType.NAVIGATION,
    superFlag: null,
    childrenMenus: [],
  },
];
